import { useCallback, useMemo } from "react";
import { useTheme } from "@material-ui/core";
import { createStyles, makeStyles } from "@material-ui/core/styles";
import { Theme } from "@material-ui/core";
import { useAtomicStyles } from "styles";
import { useForm } from "react-hook-form";
import { actions, selectors } from "redux-store";
import { useDispatch, useSelector } from "react-redux";
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import { useTypedTranslations } from "hooks";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    actions: {
      justifyContent: "space-between",
      marginTop: "1em",
    },
  }),
);

const schema = yup.object().shape({
  name: yup
    .string()
    .required("Inserisci un nome")
    .min(3, "Deve avere almeno tre caratteri")
    .max(30, "Deve avere al massimo 30 caratteri"),
});

const useCreateMerchantForm = () => {
  const theme = useTheme();
  const styles = useStyles(theme);
  const classes = useMemo(
    () => ({
      actions: {
        root: styles.actions,
      },
    }),
    [styles],
  );
  const atomicStyles = useAtomicStyles();
  const { register, handleSubmit, errors } = useForm<{
    name: string;
  }>({
    resolver: yupResolver(schema),
  });
  const dispatch = useDispatch();
  const isCreatingMerchant = useSelector(
    selectors.getAjaxIsLoadingByApi(actions.postMerchants.api),
  );
  const [t] = useTypedTranslations();

  const onClose = useCallback(() => {
    dispatch(actions.setIsCreateMerchantDialogOpen(false));
  }, [dispatch]);

  const onSubmit = useMemo(
    () =>
      handleSubmit((data) => {
        if (!isCreatingMerchant) {
          dispatch(actions.postMerchants.request({ name: data.name }));
        }
      }),
    [dispatch, handleSubmit, isCreatingMerchant],
  );

  return {
    styles,
    classes,
    atomicStyles,
    register,
    onSubmit,
    handleSubmit,
    errors,
    onClose,
    isCreatingMerchant,
    t,
  };
};

export { useCreateMerchantForm as default };
